import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import FeatureFeed from '../../../components/feature_feed/feature_feed';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import AllFeed from '../../../components/all_feed/all_feed';
import VideoModule from '../../../components/video_module/video_module';
import MoreStories from '../../../components/more-stories-component/more-stories-component';
import { allFeedAllStoriesRendered } from '../../../../redux/action_creators/all_feed_action_creators';

// eslint-disable-next-line react/prefer-stateless-function
class Homepage extends Component {
  render() {
    const { config, homepageTag } = this.props;
    const currentSite = get(config, 'site');
    const env = get(config, 'env');
    const tags = get(homepageTag, 'posts[0].tags') || [];

    if (this.props.homepage.error) {
      return (
        <section className="homepage-page">
          <article className="homepage-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.homepage.isLoading) {
      return (
        <section className="homepage-page">
          <article className="homepage-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const adData = get(this.props, 'homepage.ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    return (
      <section className="homepage-page">
        <Ad {...combinedAdModel} name="oop" slug="false" oop="true" />

        <FeatureFeed
          featuredFeed={this.props.featuredFeed}
          scrollingModule={this.props.scrollingModule}
          combinedAdModel={combinedAdModel}
          currentSite={currentSite}
          page={'homepage'}
          isPromoting={currentSite === 'fastcompany'}
          featuredSponsoredCard={this.props.featuredSponsoredCard}
        />

        {get(this.props, 'featuredFeed.top').length >= 2
          ? <div className="homepage-page__ff-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_2" />
              <Ad {...combinedAdModel} name="mobilerectangle_1" />
            </div>
          : ''}

        <section className="homepage-tag">
          <MoreStories
            metadata={get(this.props, 'homepageTag.posts')}
            slugData={get(this.props, 'homepageTag.tags[0]')}
            tags={tags}
            currentSite={currentSite}
          />
        </section>

        {get(this.props, 'homepageTag.posts').length
          ? <div className="homepage-page__tag-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_4" />
              <Ad {...combinedAdModel} name="mobileparallax_2" />
            </div>
          : ''}

        <VideoModule
          data={this.props.homepageVideo}
          playerid="76APbejE"
          stories={this.props.homepageVideo.playlist}
          currentSite={currentSite}
        />

        {get(this.props, 'homepageVideo.playlist').length
          ? <div className="homepage-page__video-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_3" />
              <Ad {...combinedAdModel} name="mobilerectangle_2" />
            </div>
          : ''}

        <AllFeed
          adModel={combinedAdModel}
          stories={get(this.props, 'allFeed.posts')}
          allRendered={get(this.props, 'allFeed.allRendered')}
          updateAction={allFeedAllStoriesRendered}
          currentSite={currentSite}
          env={env}
        />

        {this.props.allFeed.posts.length
          ? <div className="homepage-page__all-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_5" />
              <Ad {...combinedAdModel} name="mobilerectangle_4" />
            </div>
          : ''}
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config,
    scrollingModule: get(state, 'scrollingModule.data') || {},
    featuredSponsoredCard: get(state, 'featuredSponsoredCard.data') || {},
    allFeed: {
      allRendered: get(state, 'allFeed.allRendered') || false,
      posts: get(state, 'allFeed.data.posts') || []
    },
    homepageVideo: {
      playlist: get(state, 'homepageVideo.data.playlist') || [],
      title: get(state, 'homepageVideo.data.title') || '',
      feedid: get(state, 'homepageVideo.data.feedid') || ''
    },
    featuredFeed: {
      source: get(state, 'featuredFeed.data.source') || '',
      top: get(state, 'featuredFeed.data.top') || [],
      featured: get(state, 'featuredFeed.data.featured') || []
    },
    homepageTag: {
      tags: get(state, 'homepageTag.data.tags') || [],
      posts: get(state, 'homepageTag.data.posts') || []
    },
    homepage: state.homepage || {}
  };
}

Homepage.propTypes = {
  config: PropTypes.shape({}).isRequired,
  homepage: PropTypes.shape({
    ads: PropTypes.object,
    error: PropTypes.bool,
    isLoading: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  homepageVideo: PropTypes.shape({
    playlist: PropTypes.arrayOf(PropTypes.shape({})),
    feedid: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  homepageTag: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.shape({})),
    posts: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  scrollingModule: PropTypes.shape({}).isRequired,
  featuredSponsoredCard: PropTypes.shape({}).isRequired,
  allFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool
  }).isRequired,
  featuredFeed: PropTypes.shape({
    source: PropTypes.string,
    featured: PropTypes.arrayOf(PropTypes.shape({})),
    top: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired
};

export default connect(mapStateToProps)(Homepage);



// WEBPACK FOOTER //
// ./src/views/containers/pages/index_page/index_page.js